import React from "react";
import {PRODUCT_TYPES} from "../../../api/products/productBaseConstants";

export const RollsetProductList = ({products}) => {
  return (
    <ul>
      {Object.entries(products.toJS())
        .map(([productType, productsData]) => Object.values(productsData).map(item => {
        item.type = productType;
        return item
      }).sort(
            (productData1, productData2) => {
              return (productData1.price < productData2.price ? 1 : -1);

            }).map(
          productData => <li className='rollset-item' key={productData.id}>

            {productData.type === PRODUCT_TYPES.roll.id ? `#${productData.code}` : ''} {`${productData.title}`}
            &nbsp;
            {productData.type === PRODUCT_TYPES.roll.id && `${productData.count*8}`}
            {productData.type !== PRODUCT_TYPES.roll.id && productData.productSubtype !== 'cookie' && productData.type !== PRODUCT_TYPES.poke.id && `${productData.count}`}
            &nbsp;
            {productData.productSubtype !== 'cookie' && productData.type !== PRODUCT_TYPES.poke.id && `шт`}

          </li>
        ))}
    </ul>
  )
};
